
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 820.9 820.9"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M604.5 385.4H276.8l131.1-131.1c9.8-9.8 9.8-25.6 0-35.4-9.8-9.8-25.6-9.8-35.4 0L181.1 410.4l191.4 191.4c9.7 9.8 25.6 9.9 35.4.2s9.9-25.6.2-35.4l-.2-.2-131.1-131h327.7c13.8 0 25-11.2 25-25s-11.2-25-25-25z"}}),_c('path',{attrs:{"d":"M788.6 250.7C700.4 41.1 459-57.2 249.4 31S-58.4 360.7 29.8 570.2 359.5 878.1 569 789.8C721.6 725.5 820.9 576 820.9 410.4c.1-54.8-10.9-109.2-32.3-159.7zM665.3 665.3C524 805.6 295.8 804.7 155.5 663.5 16 522.9 16 296.1 155.6 155.6c141.3-140.3 369.5-139.4 509.8 1.8 139.5 140.6 139.5 367.4-.1 507.9z"}})])
          )
        }
      }
    